<template>
    <td-dialog :lockScroll="false" :title="$t(title)" :before-close="dbDialogClose" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="fromThirdPartyInfo" label-position="right" label-width="85px" ref="fromThirdPartyInfo" :rules="rules">
            <el-form-item :label="$t('pgCommon.PRIMARY_KEY')" prop="primaryKey">
                <td-input v-model="fromThirdPartyInfo.primaryKey" maxlength="50" :disabled="keyDisabled"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.PROPERTY_NAME')" prop="description">
                <td-input v-model="fromThirdPartyInfo.description"> </td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.QUEST_TYPE')" prop="questType">
                <td-radio v-model="fromThirdPartyInfo.questType" :options="optionsType" @change="changeType"></td-radio>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.METHOD_URL')" prop="methodUrl">
                <template slot="error"> </template>
                <td-input v-popover:popover v-model="fromThirdPartyInfo.methodUrl" width="100%"></td-input>
            </el-form-item>
            <el-form-item v-show="paramShow" :label="$t('pgCommon.PARAM')" prop="param">
                <td-input v-model="fromThirdPartyInfo.param" type="textarea" width="100%"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.VALUE')" prop="value">
                <td-input v-model="fromThirdPartyInfo.value" type="textarea" readonly="true" width="100%"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button @click="connectThirdParty('fromThirdPartyInfo')" :loading="connectLoading">{{ $t('pgCommon.DATABASE_CONN_TEST') }}</td-button>
            <td-button type="primary" @click="submitForm('fromThirdPartyInfo')" :loading="submitLoading">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="dbDialogClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from './../assets/api.js';
export default {
    props: ['title', 'dialogVisible', 'editItem', 'isAddData'],
    created() {
        this.initParamJson();
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.keyDisabled = true;
            this.initEditData();
        }
    },
    // 定义变量
    data() {
        //验证参数JSON格式
        let validateParam = (rule, value, callback) => {
            if (typeof value == 'string') {
                try {
                    JSON.parse(value);
                    callback();
                } catch (e) {
                    callback(new Error(this.$t('pgError.ERROR_INPUT_JSON')));
                }
            }
        };
        return {
            // db表单信息
            fromThirdPartyInfo: {
                primaryKey: '',
                methodUrl: '',
                questType: 0,
                description: '',
                param: '',
                value: ''
            },
            paramShow: true,
            connectLoading: false, // 连接测试按钮是否为加载状态
            submitLoading: false, // 保存按钮是否为加载状态
            keyDisabled: false, // 主键是否为只读状态
            optionsType: [
                //请求类型
                {
                    value: 0,
                    label: this.$t('pgCommon.QUEST_TYPE_POST')
                },
                {
                    value: 1,
                    label: this.$t('pgCommon.QUEST_TYPE_GET')
                }
            ],
            // 对表单进行数据验证
            rules: {
                primaryKey: [
                    { required: true, message: this.$t('pgError.ERROR_INPUT_PRIMARY_KEY_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('pgError.ERROR_MAX_LENGTH'), trigger: 'blur' },
                    { pattern: window.pangu.regex.ENGLISH_AND_NUM_UNDERLINE, message: this.$t('pgRegex.ONLY_ENGLISH_NUM_UNDERLINE'), trigger: 'hover' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                methodUrl: [
                    { required: true, message: this.$t('pgError.ERROR_INPUT_URL_NULL'), trigger: 'blur' },
                    { pattern: window.pangu.regex.URL, message: this.$t('pgError.ERROR_IP') }
                ],
                description: [
                    { required: true, message: this.$t('pgError.ERROR_INPUT_PROPERTY_NAME_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                questType: [{ required: true, message: this.$t('pgError.ERROR_SELECT_QUEST_TYPE_NULL'), trigger: 'blur' }],
                param: [{ validator: validateParam, trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.fromThirdPartyInfo.primaryKey = this.editItem.sKey;
            this.fromThirdPartyInfo.methodUrl = this.editItem.sUrl;
            this.fromThirdPartyInfo.description = this.editItem.sDescription;
            this.fromThirdPartyInfo.param = this.editItem.sParams;
            if (!this.$util.isEmpty(this.editItem.sValue)) {
                this.fromThirdPartyInfo.value = this.formatJson(this.editItem.sValue);
            } else {
                this.fromThirdPartyInfo.value = '';
            }
            this.fromThirdPartyInfo.questType = this.editItem.iMode;
            if (this.editItem.iMode == 0) {
                this.paramShow = true;
            } else {
                this.paramShow = false;
            }
            this.dbFlgReadonly = true;
        },
        // 连接第三方接口测试
        connectThirdParty(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.connectLoading = true;
                    var content = {
                        sUrl: this.fromThirdPartyInfo.methodUrl,
                        iMode: this.fromThirdPartyInfo.questType,
                        sParams: this.fromThirdPartyInfo.param
                    };
                    resourceApi.testThirdPartyUrl(JSON.stringify(content), response => {
                        this.connectLoading = false;
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            this.$log.error('thirdPartyController/testThirdPartyUrl', response);
                            return;
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('thirdPartyController/testThirdPartyUrl', response.data.statusMessage);
                            return;
                        }
                        if (!this.$util.isEmpty(response.data.content)) {
                            this.fromThirdPartyInfo.value = this.formatJson(response.data.content);
                        }
                        this.$message({ showClose: true, message: this.$t('pgCommon.THIRD_PARTY_CONN_SUCC'), type: 'success' });
                    });
                }
            });
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    var content = {
                        sKey: this.fromThirdPartyInfo.primaryKey,
                        sUrl: this.fromThirdPartyInfo.methodUrl,
                        sDescription: this.fromThirdPartyInfo.description,
                        sParams: this.fromThirdPartyInfo.param,
                        iMode: this.fromThirdPartyInfo.questType,
                        sValue: this.fromThirdPartyInfo.value
                    };
                    if (this.isAddData) {
                        resourceApi.insertThirdPartyInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('thirdPartyController/insertThirdPartyInfo', response.data.statusMessage);
                                this.submitLoading = false;
                                return;
                            }
                            this.submitLoading = false;
                            this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS'), type: 'success' });
                            this.dbDialogClose();
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('btnQuery');
                        });
                    } else {
                        content.sId = this.editItem.sId;
                        resourceApi.updateThirdPartyInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('thirdPartyController/updateThirdPartyInfo', response.data.statusMessage);
                                this.submitLoading = false;
                                return;
                            }
                            this.submitLoading = false;
                            this.$message({ showClose: true, message: this.$t('pgCommon.MODIFY_SUCCESS'), type: 'success' });
                            this.dbDialogClose();
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('btnQuery');
                        });
                    }
                }
            });
        },
        initParamJson() {
            let paramJson = {};
            this.fromThirdPartyInfo.param = this.formatJson(paramJson);
        },
        formatJson(json) {
            let reg = null;
            let formatted = '';
            let pad = 0;
            let PADDING = '    ';
            let options = {};
            options.newlineAfterColonIfBeforeBraceOrBracket = options.newlineAfterColonIfBeforeBraceOrBracket === true;
            options.spaceAfterColon = options.spaceAfterColon !== false;
            if (typeof json !== 'string') {
                json = JSON.stringify(json);
            } else {
                json = JSON.parse(json);
                json = JSON.stringify(json);
            }
            reg = /([{}])/g;
            json = json.replace(reg, '\r\n$1\r\n');
            reg = /([[\]])/g;
            json = json.replace(reg, '\r\n$1\r\n');
            reg = /(,)/g;
            json = json.replace(reg, '$1\r\n');
            reg = /(\r\n\r\n)/g;
            json = json.replace(reg, '\r\n');
            reg = /\r\n,/g;
            json = json.replace(reg, ',');
            if (!options.newlineAfterColonIfBeforeBraceOrBracket) {
                reg = /:\r\n\{/g;
                json = json.replace(reg, ':{');
                reg = /:\r\n\[/g;
                json = json.replace(reg, ':[');
            }
            if (options.spaceAfterColon) {
                reg = /:/g;
                json = json.replace(reg, ':');
            }
            json.split('\r\n').forEach(function(node) {
                if (node === '') {
                    return;
                }
                let i = 0;
                let indent = 0;
                let padding = '';

                if (node.match(/\{$/) || node.match(/\[$/)) {
                    indent = 1;
                } else if (node.match(/\}/) || node.match(/\]/)) {
                    if (pad !== 0) {
                        pad -= 1;
                    }
                } else {
                    indent = 0;
                }

                for (i = 0; i < pad; i++) {
                    padding += PADDING;
                }

                formatted += padding + node + '\r\n';
                pad += indent;
            });
            return formatted;
        },
        changeType(value) {
            if (value == 0) {
                this.paramShow = true;
            }
            if (value == 1) {
                this.paramShow = false;
            }
            this.initParamJson();
            this.fromThirdPartyInfo.value = '';
        },
        // 关闭窗口之前需要调用的方法
        dbDialogClose() {
            this.$emit('dbDialogClose');
            this.$refs['fromThirdPartyInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
